import Container from '@material-ui/core/Container'
import React, { FC } from 'react'
import { Helmet } from 'react-helmet'
import { Content, ImageContainer, Section, Wrapper } from '../styles/404'

//* components
import Layout from '../components/layouts/layout'

//* utils
import notFoundImg from '../../static/steam-img/404-img-new.png'
import { LocaleCodes } from '../constants/localization.constants'
import { MenuNav } from '../models/others/menuNav'

type Props = {
  lang: string
  footerData: MenuNav
  headerData: MenuNav
  announcementData: any
  browserLanguageData: any
}

const RootIndex: FC<Props> = ({
  lang,
  footerData,
  headerData,
  announcementData,
  browserLanguageData,
}) => {
  const pageTitle: string = 'UiPath | 404'

  return (
    <Layout.Template
      lang={lang || LocaleCodes.ENGLISH.code}
      footerData={footerData}
      headerData={headerData}
      announcementData={announcementData}
      browserLanguageData={browserLanguageData}>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>

      <Container data-cy="Page404">
        <Section>
          <Wrapper>
            <ImageContainer src={notFoundImg} />
            <Content>
              <h2 className="Black">We’re stumped! Sorry!</h2>

              <p className="section-p">
                We might have moved or deleted that page. Please double-check the URL, just to be
                sure.
              </p>

              <p className="section-p">
                If that doesn't help, you can always return to our Home Page.
              </p>

              <ul>
                <li>
                  <a href="/">Go to Home Page</a>
                </li>
              </ul>
            </Content>
          </Wrapper>
        </Section>
      </Container>
    </Layout.Template>
  )
}

export default RootIndex
